import { CSSObject } from "@emotion/react";

export const standardsContainerCss: CSSObject = {
  paddingInline: 0,
  marginBlock: 0,
};
